import { action, createRequestTypes } from '../base';

export const productV2ActionsTypes = {
  CREATE_LEDGER_ENTRY: createRequestTypes('CREATE_LEDGER_ENTRY'),
  UPDATE_LEDGER_ENTRY: createRequestTypes('UPDATE_LEDGER_ENTRY'),
};

class ProductV2Actions {
  createLedgerEntry = (payload, callback) => action(productV2ActionsTypes.CREATE_LEDGER_ENTRY.REQUEST, {
    payload,
    callback,
  })

  createLedgerEntryLoading = (createLedgerEntryLoading) => action(productV2ActionsTypes.CREATE_LEDGER_ENTRY.LOADING, {
    createLedgerEntryLoading,
  })

  updateLedgerEntry = (payload, callback) => action(productV2ActionsTypes.UPDATE_LEDGER_ENTRY.REQUEST, {
    payload,
    callback,
  })

  updateLedgerEntryLoading = (updateLedgerEntryLoading) => action(productV2ActionsTypes.UPDATE_LEDGER_ENTRY.LOADING, {
    updateLedgerEntryLoading,
  })
}

export default new ProductV2Actions();
